export const LOADER_DISCIPLINARY_CASES      =   'LOADER_DISCIPLINARY_CASES';
export const LOADER_DISCIPLINARY_CASE       =   'LOADER_DISCIPLINARY_CASE';
export const SAVE_LOADER_DISCIPLINARY_CASE  =   'SAVE_LOADER_DISCIPLINARY_CASE';
export const GET_DISCIPLINARY_CASE          =   'GET_DISCIPLINARY_CASE';
export const GET_DISCIPLINARY_CASES         =   'GET_DISCIPLINARY_CASES';
export const FAILD_DISCIPLINARY_CASE        =   'FAILD_DISCIPLINARY_CASE';
export const FAILD_DISCIPLINARY_CASES       =   'FAILD_DISCIPLINARY_CASES';
export const FORM_DISCIPLINARY_CASE_FAILD   =   'FORM_DISCIPLINARY_CASE_FAILD';

export const LOADER_DISCIPLINARY_CASES_ALL      =   'LOADER_DISCIPLINARY_CASES_ALL';
export const GET_DISCIPLINARY_CASES_ALL         =   'GET_DISCIPLINARY_CASES_ALL';
export const FAILD_DISCIPLINARY_CASES_ALL         =   'FAILD_DISCIPLINARY_CASES_ALL';

export const LOADER_COMMENTS = 'LOADER_COMMENTS';
export const GET_COMMENTS = 'GET_COMMENTS';
export const FAILD_COMMENTS = 'FAILD_COMMENTS';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const CREATE_COMMENT_FAILD = 'CREATE_COMMENT_FAILD';
export const CREATE_COMMENT_LOADER = 'CREATE_COMMENT_LOADER';
export const RESET_COMMENTS = 'RESET_COMMENTS';